import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-status-filter-buttons" }
const _hoisted_2 = { class: "recommended-wrapper" }
const _hoisted_3 = { class: "order-status-button__container" }
const _hoisted_4 = { class: "order-status-button__text" }
const _hoisted_5 = { class: "recommend-status-hint" }
const _hoisted_6 = { class: "recommend-status-hint__header" }
const _hoisted_7 = { class: "recommend-status-hint__header--title" }
const _hoisted_8 = { class: "recommend-status-hint__content" }
const _hoisted_9 = { class: "recommend-status-hint__content--description" }
const _hoisted_10 = { class: "order-status-button__container" }
const _hoisted_11 = { class: "order-status-button__text" }
const _hoisted_12 = { class: "order-status-button__container" }
const _hoisted_13 = { class: "order-status-button__text" }

import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import HelpIconWithModal from '@/corePagesModule/components/HelpIconWithModal.vue';
import { i18n } from '@/i18n';
import SvgLoader from '@/utils/SvgLoader.vue';
import { FilterStatusType } from '../entities/IOrderControl';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderStatusFilterButtons',
  props: {
    filterStatus: {},
    recordCount: {}
  },
  emits: ["updateOrderStatusFilter"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const emits = __emit;

/**
 * 表示非表示のアイコンを取得
 * @param value - 取得するアイコン
 */
const getEyeIconName = (value: string) => {
  return props.filterStatus[value] ? 'iconEyeEnabled' : 'iconEyeDisable';
};

/**
 * 0, undefinedなどを -- に変換したUI表示用数値を返す
 * @param value - 数値
 */
const getDisplayNumber = (value: number | undefined) => {
  return value || '--';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["order-status-button order-status-button--recommended", { 'order-status-button--inactive': !props.filterStatus.Recommended }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('updateOrderStatusFilter', _unref(OrderStatus).Recommended)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('推奨')), 1),
          _createElementVNode("p", null, _toDisplayString(getDisplayNumber(_ctx.recordCount.Recommended)) + " " + _toDisplayString(_unref(t)('件')), 1),
          _createVNode(SvgLoader, {
            class: "order-status-button__icon",
            name: getEyeIconName('Recommended')
          }, null, 8, ["name"])
        ])
      ], 2),
      _createVNode(HelpIconWithModal, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('推奨の出現条件')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('登録されている最新在庫日より180日先までに発注推奨が存在する場合、発注推奨が出現します。')), 1)
            ])
          ])
        ], undefined, true),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["order-status-button order-status-button--approval-requested", { 'order-status-button--inactive': !props.filterStatus.ApprovalRequested }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('updateOrderStatusFilter', _unref(OrderStatus).ApprovalRequested)))
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('承認依頼')), 1),
        _createElementVNode("p", null, _toDisplayString(getDisplayNumber(_ctx.recordCount.ApprovalRequested)) + " " + _toDisplayString(_unref(t)('件')), 1),
        _createVNode(SvgLoader, {
          class: "order-status-button__icon",
          name: getEyeIconName('ApprovalRequested')
        }, null, 8, ["name"])
      ])
    ], 2),
    _createElementVNode("button", {
      class: _normalizeClass(["order-status-button order-status-button--approved", { 'order-status-button--inactive': !props.filterStatus.ApprovedAwaitingDeliveryDate }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('updateOrderStatusFilter', _unref(OrderStatus).ApprovedAwaitingDeliveryDate)))
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('承認済')), 1),
        _createElementVNode("p", null, _toDisplayString(getDisplayNumber(_ctx.recordCount.ApprovedAwaitingDeliveryDate)) + " " + _toDisplayString(_unref(t)('件')), 1),
        _createVNode(SvgLoader, {
          class: "order-status-button__icon",
          name: getEyeIconName('ApprovedAwaitingDeliveryDate')
        }, null, 8, ["name"])
      ])
    ], 2)
  ]))
}
}

})